module.exports = __webpack_public_path__ + "img/logo28.2783c0da.png";